





























































import { Vue, Component, Watch } from 'vue-property-decorator'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { showErrors, showNotification } from '@/utils/snack'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import { findDealer } from '@/views/DealerList/gql'
import AppDialog from '@/components/AppDialog.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppSearchBtn from '@/components/AppSearchBtn.vue'
import { Goods } from '@/interfaces/goods'
import { removeGoodsFromDealer, updateDisplayOrder } from '../gql'
import { SnackType } from '@/interfaces/snack'
import draggable from 'vuedraggable'
import { TypedGqlError } from '@/interfaces/error'
import AuthFilter from '@/mixins/auth-filter'
import { mixins } from 'vue-class-component'
import DealerOrders from '../script-orders'

@Component({
  components: {
    AppBreadcrumbs,
    AppDialog,
    AppTextField,
    AppSearchBtn,
    draggable
  }
})
export default class EditDealerGoods extends mixins(AuthFilter, DealerOrders) {
  breadcrumbs: Breadcrumb[] = [];

  dealerId = '';
  dealerName = '';

  allGoods: Goods[] | null = null;
  selectedGoods: Goods[] | null = null;
  goods: any = [];

  // 定义要被拖拽对象的数组
  displayGoods: any = [];

  // 查询的顺序数组id
  displayOrders: number[] = [];

  disabledActions = true;

  windowSize = {
    w: 0,
    h: 0
  };

  actionsHeight = 51;

  get filterGoods () {
    if (this.allGoods?.length !== 0) {
      return this.allGoods?.filter((item) => {
        return !this.goods?.some((ele: any) => ele.goodId === item.id)
      })
    } else {
      return []
    }
  }

  @Watch('displayOrders', { deep: true, immediate: true })
  displayOrdersChange (val: []) {
    if (val.length !== 0) {
      const arr: any = []
      if (this.goods) {
        this.displayOrders.forEach((item: number) => {
          const goods = this.goods?.find((g: any) => {
            return item === g.goodId
          })
          arr.push(goods)
        })
      }
      this.displayGoods = arr
    }
  }

  async mounted () {
    const { id } = this.$route.params
    this.dealerId = id
    await this.getDealerById(Number(this.dealerId))
    await this.getGoodsOrders()
  }

  async getDealerById (dealerId: number) {
    try {
      const result = await this.$apollo.query({
        query: findDealer,
        variables: {
          dealerId
        }
      })
      if (result) {
        const dealer = result.data.findDealer
        this.goods = dealer?.goodRelations
        this.dealerId = dealer?.id + ''
        this.dealerName = dealer?.realname + ''
        this.breadcrumbs = [
          {
            text: '经销商管理'
          },
          {
            text: '经销商',
            to: { name: 'DealerList' }
          },
          {
            text: `${this.dealerName}`,
            to: {
              name: 'DealerDetail',
              params: { id: `${this.dealerId}` }
            }
          },
          { text: '小店商品' }
        ]
      }
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  // 更新顺序
  async updateGoodsOrders () {
    const orders = this.displayGoods?.map((item: any) => {
      return item.goodId
    })
    try {
      const result = await this.$apollo.mutate({
        mutation: updateDisplayOrder,
        variables: {
          dealerId: +this.dealerId,
          orders
        }
      })
      if (result) {
        showNotification({
          msg: '保存成功',
          type: SnackType.Info
        })
        this.disabledActions = true
        this.$router.go(-1)
      }
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  // 删除商品
  async deleteGoods (item: Goods) {
    const goodIds = []
    goodIds.push(item.id)
    try {
      const result = await this.$apollo.mutate({
        mutation: removeGoodsFromDealer,
        variables: {
          dealerId: +this.dealerId,
          goodIds
        }
      })
      if (result) {
        showNotification({
          msg: '删除成功',
          type: SnackType.Info
        })
        await this.getDealerById(Number(this.dealerId))
        await this.getGoodsOrders()
      }
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  onResize () {
    this.windowSize = { w: window.innerWidth, h: window.innerHeight }
    const actionDom = this.$refs.actions as Vue & {
      clientHeight: number;
    }
    this.actionsHeight = actionDom.clientHeight
  }

  async beforeRouteLeave (to: any, from: any, next: any) {
    if (!this.disabledActions) {
      const res = confirm('页面修改尚未保存，是否确定要离开？')
      next(res)
    } else {
      next()
    }
  }
}
